import { inject } from '@angular/core';
import { CanDeactivateFn } from '@angular/router';
import { ModalService } from '@totalenergiescode/tds-angular';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import {
  UnsavedChangesModalComponent,
  UnsavedChangesResult,
} from '../components/unsaved-changes-modal/unsaved-changes-modal.component';

export interface HasUnsavedChanges {
  isDirty: () => boolean;
  isReadOnly: () => boolean;
  editorSave: () => Observable<boolean>;
}

export const UnsavedChangesGuard: CanDeactivateFn<HasUnsavedChanges> = (
  component: HasUnsavedChanges
): boolean | Observable<boolean> => {
  if (!component.isDirty() || component.isReadOnly()) {
    return true;
  }

  const modalService = inject(ModalService);

  return new Observable<boolean>((observer) => {
    modalService.open({
      content: {
        component: UnsavedChangesModalComponent,
      },
      onClose: (result?: UnsavedChangesResult) => {
        if (result === 'save') {
          // Save and then allow navigation
          component
            .editorSave()
            .pipe(map(() => true))
            .subscribe({
              next: (canLeave) => {
                observer.next(canLeave);
                observer.complete();
              },
              error: () => {
                // Save failed — block navigation
                observer.next(false);
                observer.complete();
              },
            });
        } else if (result === 'discard') {
          observer.next(true);
          observer.complete();
        } else {
          // Cancel
          observer.next(false);
          observer.complete();
        }
      },
    });
  });
};
